export default __webpack_public_path__ + "static/Floorplan - FLV-237f754e64bd0436f420069a5872e575.pdf";